import React from "react";

const Pricewrite = () => {
  return (
    <section className="price-cta">
      <h3 className="starter">Starting from</h3>
      <h3 className="money">$30</h3>
    </section>
  );
};

export default Pricewrite;
